
        Component.define('recipes', (el, params) => {
            function setRecipeHowHeight(){
    const $recipe        = $el.find('.recipe-item-modal.opened');
    const $recipeHow     = $recipe.find('.recipe-how-to');
    const $recipeDetails = $recipe.find('.recipe-details');
    const height         = $window.height() - $recipe.find('.recipe-title').outerHeight();

    if ($recipe.length){
        $recipeHow.height(height);
    }
}

const $el           = $(el);
const $btnClose     = $el.find('.btn-close');

let scroll = $window.scrollTop();

const open = ($recipe) => {
    const $recipeHow = $recipe;

    if (!$recipe.hasClass('opened')) {
        TweenMax.set($recipe, { opacity: 1 });
        $recipe.find('[data-animated="true"]').removeAttr('data-animated');
        $recipe.addClass('opened');

        scroll = $window.scrollTop();
        $('html, body').toggleClass('page-overflow-hidden');

        setRecipeHowHeight();

        $window.trigger('scroll');
    }
};

const close = () => {
    const $active = $el.find('.recipe-item-modal.opened');

    $('html, body').removeClass('page-overflow-hidden');
    $window.scrollTop(scroll);
    $window.trigger('scroll');

    TweenMax.to($active, .4, { opacity: 0, onComplete() {
        $active.removeClass('opened');
        $window.trigger('scroll');
    }});
};

$btnClose.on('click', function (e) {
    close();
});

$window.on('resize', function (){
    setRecipeHowHeight();
});

$el.on('recipes:open', function (e, $recipe){
    open($recipe);
});

        });